import { initializeApp } from "firebase/app";

export default defineNuxtPlugin((nuxtApp) => {
  const {
    firebaseApiKey,
    firebaseAppId,
    firebaseAuthDomain,
    firebaseProjectId,
    firebaseStorageBucket,
    firebaseMessagingSenderId,
    firebaseMeasurementId,
  } = useRuntimeConfig().public;
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: firebaseApiKey,
    authDomain: firebaseAuthDomain,
    projectId: firebaseProjectId,
    storageBucket: firebaseStorageBucket,
    messagingSenderId: firebaseMessagingSenderId,
    appId: firebaseAppId,
    measurementId: firebaseMeasurementId,
  };

  let firebaseApp: ReturnType<typeof initializeApp> | undefined = undefined;
  try {
    firebaseApp = initializeApp(firebaseConfig);
    if (firebaseApp) {
      nuxtApp.provide("firebaseApp", firebaseApp);
    }
  } catch (e) {
    console.dir(e);
    //
  }
});
